import { useEffect, useState } from 'react';
import { Company } from 'us-web-services';
import { zendesk } from '../services/zendesk.service';

const useZendesk = (company: Company, parentId: number | undefined) : boolean => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const { zendeskEnabled } = company;
    if (!zendeskEnabled || !parentId) {
      document.getElementById('ze-snippet')?.remove();
      setReady(false);
      return;
    }
    zendesk.init().then(() => {
      const interval = setInterval(() => {
        if (window.zE) {
          setReady(true);
          clearInterval(interval);
        }
      }, 50);

      setTimeout(() => clearInterval(interval), 3000);

      if (zendeskEnabled && window.zE) zendesk.identifyUser(parentId);
    });
  }, [company, parentId]);

  return ready;
};

export default useZendesk;
